// extracted by mini-css-extract-plugin
export var icon = "_78cc2";